import { render } from "./downloadAppIndex.vue?vue&type=template&id=ef33f1be&scoped=true"
import script from "./downloadAppIndex.vue?vue&type=script&lang=js"
export * from "./downloadAppIndex.vue?vue&type=script&lang=js"

import "./downloadAppIndex.vue?vue&type=style&index=0&id=ef33f1be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef33f1be"]])

export default __exports__